import axios from 'axios';
import setupAxios from './setup-axios';
import withCompanyScope from './company-scope';

// const bookingInstance = axios.create({
//   baseURL: import.meta.env.VITE_APP_BOOKING_API_URL,
//   // timeout: 10000,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// bookingInstance.interceptors.request.use(
//   config => {
//     const auth = localStorage.getItem('auth');

//     if (auth != null) {
//       const accessToken = JSON.parse(auth ?? '').state.access_token;

//       config.headers.Authorization = `Bearer ${accessToken}`;
//     }

//     return config;
//   },
//   error => Promise.reject(error)
// );

// bookingInstance.interceptors.response.use(
//   response => response,
//   error => {
//     if (error.response?.status === 401) {
//       localStorage.removeItem('auth');
//       window.location.href = '/';
//     }
//     return Promise.reject(error);
//   }
// );
const bookingInstance = withCompanyScope(
  setupAxios(
    axios.create({
      baseURL: import.meta.env.VITE_APP_BOOKING_API_URL,
      headers: { 'Content-Type': 'application/json' },
    })
  )
);

export default bookingInstance;
